import React, { Fragment } from "react";
import { reports } from "../../data/reportsData";
import BreadCrumb from "../BreadCrumb/BreadCrumb";
import ListItem from "../ListItem/ListItem";

const ReportsMenu = () => {
  return (
    <Fragment>
      <BreadCrumb
        margin="mt-3"
        num1="واحد حسابداری"
        num2="گزارشات"
        // num3="تحویل داده شده"
      />
      <ListItem items={reports} />
    </Fragment>
  );
};

export default ReportsMenu;
